var UnitHandles = {
  ASSASSIN: 'assassin',
  BATTLE_MAGE: 'battle_mage',
  DREAMSMITH: 'dreamsmith',
  INVOKER: 'invoker',
  KNIGHT: 'knight',
  MERCENARY: 'mercenary',
  MONK: 'monk',
  PALADIN: 'paladin',
  RANGER: 'ranger',
  SHAMAN: 'shaman',
  WARLOCK: 'warlock'
}
module.exports = UnitHandles
